import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../components/SelectPicker';
import FormInput from '../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        // 'titlebar=yes',
        // 'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    ]
};

Vue.use(VueHtmlToPaper, options);

export default {
    name: "trips",
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            selected: null,
            clickForSelected: false,
            loading_states: {
                list: false,
                activate: false,
                departure: false,
                arrive: false,
                cancel: false,
                edit: false,
                print: false,
                cancelPassenger: false,
            },
            scrollTop: 0,
            trips: [],
            status_filters: [
                {id: -1, name: this.i18n('Everything')},
                {id: 10, name: this.i18n('Active')},
                {id: 0, name: this.i18n('Cancelled')},
                {id: 2, name: this.i18n('On the way')},
                {id: 3, name: this.i18n('Arrived')}
            ],
            filter_status: null,
            station_from: null,
            station_to: null,
            passengers: [],
            stations_list: [],
            buses_list: [],
            drivers_list: [],
            transporters_list: [],
            bus_models_list: [],
            trip_date: null,
            trip4Dep: null,
            printData: null,
            editing: false,
            editing_fields: {
                bus_id: 0,
                driver_id: 0,
                bus_model_id: 0,
                transporter_id: 0,
                platform: null,
            },
            statement: false,
            tripPassengers: [],
        };
    },
    methods: {
        loadTrips(callback = null) {
            this.$store.commit('tripDate', this.formattedDate);
            this.loading_states.list = true;
            this.selected = null;
            let postData = {};
            postData.date = this.formattedDate;
            if (this.station_from !== null) {
                postData.from = this.station_from;
            }
            if (this.station_to !== null) {
                postData.to = this.station_to;
            }
            if (this.filter_status !== null && this.filter_status !== -1) {
                postData.status = this.filter_status;
            }
            this.$api.post('trips.data', postData).then(({data}) => {
                this.trips = data;
            }).finally(() => {
                this.loading_states.list = false;
                if (callback !== null) callback();
            });
        },
        arriveTrip() {
            this.loading_states.arrive = true;
            this.$api.post('trips.arrive', {}, {id: this.selected}).then(({data}) => {
                this.loadTrips(() => {
                    this.selected = data.id;
                });
            }).finally(() => {
                this.loading_states.arrive = false;
            });
        },
        departureBeforeCheck(){
            this.loading_states.departure = false;
            this.$refs.modalCloser.click();
            this.$api.post('trips.checkPassBeforeDeparture', {}, {id: this.selected}).then(response => {
                this.departureTrip();
            }).catch(error => {

                if(confirm(error.response.data.alert)){
                    this.departureTrip();
                }
            }).finally(() => {
                this.loading_states.departure = false;
                this.$refs.modalCloser.click();
            });
        },
        departureTrip() {
            // this.loading_states.departure = true;


            this.$api.post('trips.departure', {}, {id: this.selected}).then(({data}) => {
                this.loadTrips(() => {
                    this.selected = data.id;
                });
            }).catch(error => {
                // this.$store.commit("errorNotifyByText", error.response.data.alert);
            }).finally(() => {
                // this.loading_states.departure = false;
                // this.$refs.modalCloser.click();
            });
        },
        editTrip() {
            this.loading_states.edit = true;
            let data = {};
            if (this.editing) data = {edited: 1, editedData: this.editing_fields};
            this.$api.post('trips.edit', data, {id: this.selected}).then(({data}) => {
                this.loadTrips(() => {
                    this.selected = data.id;
                });
            }).finally(() => {
                this.loading_states.edit = false;
                this.$refs.modalCloser.click();
            });

        },
        activateTrip() {
            this.loading_states.activate = true;
            this.$api.post('trips.activate', {}, {id: this.selected}).then(({data}) => {
                this.loadTrips(() => {
                    this.selected = data.id;
                });
            }).finally(() => {
                this.loading_states.activate = false;
            });
        },
        cancelTrip() {
            this.loading_states.cancel = true;
            this.$api.post('trips.cancel', {}, {id: this.selected}).then((res) => {
                if (!res.errors) {
                    this.loadTrips(() => {
                        this.selected = res.data.id;
                    });
                } else {
                    this.tripPassengers = res.errors.passengers;
                    $('#tripPassengers').modal('show');
                }
            }).finally(() => {
                this.loading_states.cancel = false;
            });
        },
        loadTrip4Dep(editing) {
            this.editing = editing;
            this.$api.get('trips.trip4dep', {id: this.selected}).then(({data}) => {
                this.trip4Dep = data.trip;
                this.editing_fields = {
                    bus_id: data.trip.bus_id,
                    driver_id: data.trip.driver_id,
                    transporter_id: data.trip.transporter_id,
                    bus_model_id: data.trip.bus_model_id,
                    platform: data.trip.platform,
                };
                this.buses_list = data.buses;
                this.drivers_list = data.drivers;
                this.transporters_list = data.transporters;
                this.bus_models_list = data.bus_models;

            }).finally(() => {
            });
        },
        loadPassengers() {
            this.$api.get('trips.boarded-passengers', {id: this.selected}).then(({data}) => {
                this.passengers = data;
            }).finally(() => {
            });
        },
        loadStations() {
            let searchData = {};
            this.$api.get('trips.stations', searchData).then(({data}) => {
                //this.stations_list = data;
                let stations_list = data;
                // stations_list = this.changePosition(stations_list, "Гишт-Куприк", 0);
                // stations_list = this.changePosition(stations_list, "Чирчик", 0); //alx Chirchik goes first
                this.stations_list = stations_list;
            });
        },
//alx
        changePosition(arr, name, position) {
            let idx = arr.map(object => object.name).indexOf(name);
            if (idx != -1 && idx != position) {
                let element = arr[idx];
                arr.splice(idx, 1);
                arr.splice(position, 0, element);


                //let tmp = arr[idx];
                //arr[idx] = arr[position];
                //arr[position] = tmp;
            }
            return arr;
        },
        itemClicked(trip) {
            if (this.selected === trip.trip_id)
                this.selected = null;
            else
                this.selected = trip.trip_id;
            this.clickForSelected = true
        },
        upButtonPressed() {
            this.moveSelection('up')
        },
        downButtonPressed() {
            this.moveSelection('down')
        },
        moveSelection(direction) {
            if (this.clickForSelected === false) return;
            if (this.trips.length === 0) return;
            if (this.selected === null) return;

            let index = this.trips.findIndex((i) => {
                return i.id === this.selected;
            });
            if (index === 0 && direction === 'up' || index === this.trips.length - 1 && direction === 'down') return;
            let nextIndex = index;
            if (direction === 'up') nextIndex--;
            if (direction === 'down') nextIndex++;
            let next = this.trips[nextIndex];
            this.selected = next.id;
        },
        fullNameOfBus(bus) {
            return bus.bus_model + ' [' + bus.bus_number + '] - ' + bus.transporter;
        },
        fullNameOfRoute(route) {
            return route.name + ' (' + route.number + ')';
        },
//alx
        countPassengersByCitizenship(data_passengers) {
            let country_cnt = [];
            for(let passengers of data_passengers) {
                if (passengers.country == null) passengers.country = {name: "Узбекистан"};
                let newc = true;
                country_cnt.forEach(function (value, i) {
                    if (value.name === passengers.country.name) {
                        country_cnt[i].cnt += 1;
                        newc = false;
                     }
                });
                if (newc) country_cnt.push({name: passengers.country.name, cnt: 1});
             }
             return country_cnt;
        },
//alx
        countPassengersTax(data_passengers) {
            let total_tax = 0;
            for(let passengers of data_passengers) {
                if (passengers.tax == null) continue;
                    total_tax += passengers.tax;
             }
             return total_tax;
        },
        countPassengersServices(data_passengers) {
            let total_service_amount = 0;
            for(let passengers of data_passengers) {
                if (passengers.service_amount == null) continue;
                    total_service_amount += passengers.service_amount;
             }
             return total_service_amount;
        },
        printMe(bool = true) {
            this.statement = bool;
            if (this.selected) {
                this.$api.get('trips.trip4print', {id: this.selected}).then(({data}) => {
                    this.printData = data;

//alx
                    this.printData.country_cnt = this.countPassengersByCitizenship(this.printData.passengers);
                    this.printData.total_tax = this.countPassengersTax(this.printData.passengers);
                    this.printData.total_service_amount = this.countPassengersServices(this.printData.passengers);

                }).finally(() => {
                    this.printStatement('printStatement');
                });
            }
        },
        exportToExcel() {
            if (!this.selected) {
                return;
            }
            let fileName = 'Ведомость_' + this.selected +'.xls';
            this.$api.download('xls.downloadTrip', {id: this.selected}).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        printStatement(statement) {
            let fontSize = this.$refs[statement].style.fontSize;
            this.$refs[statement].style.fontSize = '13.5px';
            this.displayNoneLoop = false;
            let mywindow = window.open('', 'PRINT');
            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById(statement).innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();
            this.$refs[statement].style.fontSize = fontSize;

            /*
            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 1000)
            */
        },
        ifStatus(status) {
            if (this.selectedTrip && this.selectedTrip.hasOwnProperty('trip_status')) {
                return this.selectedTrip.trip_status === status;
            }
            return false
        },
        cancelPassenger(id) {
            this.loading_states.cancelPassenger = id;
            this.$api.post('trips.cancelPassenger', {id: id}).then(({data}) => {
                this.loadPassengers();
                this.loadTrips();
                this.$notify({
                    type: 'success',
                    group: 'foo',
                    title: this.i18n('Successfully!!!'),
                    text: this.i18n('Passenger removed!')
                });
            }).then(err => {
                this.$notify({
                    type: 'error',
                    group: 'foo',
                    title: err.response.data.message,
                    text: text
                });
            }).finally(() => {
                this.loading_states.cancelPassenger = false;
            });
        },
        findPrivilege(id){
            return this.printData.privileges.find(item => {
                return item.id = id;
            })
        },
        birthDateFormat(date) {
            if (!date) {
                return;
            }
            return date.split('T')[0]; // TODO figure out what's going with moment.js with `1971-05-14T18:00:00.000Z` format
        },
        //paymentTypes(type) {
        paymentTypes(passenger) {
            let type = passenger.payment_type;
            let cashier_id = passenger.created_by;
            //alx if there is no Cashier (cashier_id is null) then show payment_type as ONLINE...  TODO: use payment orign Payme, Paynet, etc...
            if (cashier_id === null) {
                return 'Онлайн';
            }
            switch (type) {
                case 1:
                    return 'Нал.';
                case 2:
                    return 'Терм.';
            }
            return '-';
        }
    },
    computed: {
        fixed_header() {
            return this.scrollTop > 152 && this.selected !== null; // TODO: shu azgina xato ishlayapti.
        },
        formattedDate: function () {
            let date = new Date(this.trip_date);
            return date.getFullYear() + '-' +
                (date.getMonth() + 1) + '-' +
                date.getDate();
        },
        selectedTrip() {
            return this.trips.find(item => item.trip_id === this.selected);
        },
        ifSelected() {
            return this.trips.findIndex(item => item.trip_id === this.selected) !== -1;
        },
        buses_for_edit: function () {
            return this.buses_list.filter(x => x.transporter_id === this.editing_fields.transporter_id);
        },
        bus_model_for_edit: function () {
            let bus = this.buses_list.find(b => b.id === this.editing_fields.bus_id);
            if (bus) {
                return this.bus_models_list.find(m => m.id === bus.bus_model_id);
            }
            return {};
        },
        canDeparture() {
            return this.selected !== null && this.ifStatus(10) && this.selectedTrip.bus_id && this.selectedTrip.driver_id && this.selectedTrip.transporter_id;
        },
        canEdit() {
            return this.selected !== null && this.ifStatus(10) && this.editing_fields.bus_id && this.editing_fields.driver_id && this.editing_fields.transporter_id;
        },
        isLoading() {
            return (this.loading_states.list || this.loading_states.activate || this.loading_states.departure || this.loading_states.arrive || this.loading_states.cancel || this.loading_states.edit);
        }
    },
    filters: {
        passengerStatus(v) {
            if (v === 1) {
                return 'Бронирован'
            } else if (v === 2) {
                return 'Не приехал'
            } else if (v === 3) {
                return 'Приехал'
            }
        }
    },
    watch: {
        trip_date: function () {
            this.loadTrips()
        },
        station_from: function (n, o) {
            n !== o && this.loadTrips();
        },
        station_to: function (n, o) {
            n !== o && this.loadTrips();
        },
        filter_status: function (n, o) {
            n !== o && this.loadTrips();
        },
        selected: function () {
            this.trip4Dep = null;
            this.passengers = [];
        }
    },
    mounted() {
        this.$mousetrap.bind('up', this.upButtonPressed);
        this.$mousetrap.bind('down', this.downButtonPressed);
        window.addEventListener('mouseup', () => {
            this.clickForSelected = !1
        });
        window.addEventListener('scroll', (e) => {
            this.scrollTop = document.documentElement.scrollTop;
        });
        $('#departureModal').on("hidden.bs.modal", () => {
                this.editing = false;
            }
        );
    },
    created() {
        this.trip_date = this.$store.state.trips.date || this.$moment().format("YYYY-MM-DD");
        this.loadStations();
    },
}
